import React from "react";
import { Link } from "react-router-dom";
import { getFullImageUrl } from "../services/api";

const PromoBanner = ({ content }) => {
  const data = content || {
    title: "SIÊU SALE GIÀY HIỆU",
    subtitle: "Ưu đãi mới",
    highlight: "GIAO HÀNG HỎA TỐC - GIẢM GIÁ ĐẾN 50% - VOUCHER FREESHIP",
    description: "Nike, Adidas, Vans, Jordan, Gucci",
    image: "https://go-sporty.monamedia.net/wp-content/uploads/2025/04/banner_1.webp",
    link: "/products"
  };

  const highlightItems = data.highlight.split("-").map(item => item.trim());

  return (
    <section
      className="relative w-full max-w-[2381px] h-auto md:h-[550px] overflow-hidden bg-white dark:bg-slate-950 border border-gray-100 dark:border-slate-900 shadow-2xl flex items-center tech-grid transition-colors duration-500 py-0 pb-10 md:py-0 md:pb-0"
      data-purpose="main-banner-container"
      id="promo-banner"
    >
      {/* Background Decorative Elements */}
      <div className="decor-line top-20 -left-20 hidden md:block"></div>
      <div className="decor-line top-60 -left-10 opacity-50 hidden md:block"></div>
      <div className="glow-effect top-0 right-1/4 hidden md:block"></div>

      {/* Large Background Text (Watermark style) */}
      <div className="absolute inset-0 flex items-center justify-center select-none pointer-events-none overflow-hidden">
        <span className="text-[80px] md:text-[180px] font-black text-gray-100 dark:text-slate-900 uppercase leading-none opacity-40 dark:opacity-20 transition-colors">
          TECH
        </span>
      </div>

      <div className="container mx-auto px-6 md:px-20 flex flex-col md:flex-row items-center justify-between relative z-10 h-full gap-10 md:gap-0">
        {/* BEGIN: Left Content Area (Brand & Title) */}
        <div
          className="w-full md:w-[30%] flex flex-col gap-3 md:gap-4 text-center md:text-left pt-10 md:pt-0"
          data-purpose="brand-info"
        >
          <h2 className="text-red-600 dark:text-red-600 font-bold tracking-[0.2em] text-lg md:text-xl uppercase transition-colors">
            <span className="dark:text-white text-blue-600">TaHa </span>Shoes
          </h2>
          <h1 className="text-2xl md:text-6xl font-black text-slate-900 dark:text-white leading-tight transition-colors">
            <span className="text-gradient-tech">{data.title.split(" ")[0]}</span> <br />
            <span className="text-gradient-tech">{data.title.split(" ").slice(1).join(" ")}</span>
          </h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm md:text-lg max-w-md mx-auto md:mx-0 transition-colors px-4 md:px-0 font-medium">
            {data.description}
          </p>
        </div>
        {/* END: Left Content Area */}

        {/* BEGIN: Center Visual Area (Shoe Image) */}
        <div
          className="relative w-full md:w-[40%] md:-right-64 flex justify-center items-center h-[220px] md:h-full"
          data-purpose="shoe-visual-container"
        >
          {/* Rotated square background matching IMAGE_17 style */}
          <div className="absolute  w-[200px] h-[200px] md:w-[450px] md:h-[450px] bg-slate-900 transform rotate-[12deg] shadow-2xl"></div>

          {/* Main Shoe Image */}
          <div className="relative z-10 transform -rotate-[5deg] hover:rotate-0 transition-transform duration-500 ease-out">
            <img
              alt={data.title}
              className="w-[240px] md:w-[400px] h-auto drop-shadow-[0_20px_20px_rgba(0,0,0,0.5)] md:drop-shadow-[0_35px_35px_rgba(0,0,0,0.5)]"
              data-purpose="product-image"
              src={getFullImageUrl(data.image)}
            />
          </div>

          {/* Floating Info Tag from IMAGE_17 style */}
          <div className="absolute -bottom-2 right-0 md:bottom-14 md:right-0 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm p-3 md:p-6 rounded-xl shadow-xl z-30 border-l-4 border-blue-600 transition-colors">
            <p className="text-[8px] md:text-[10px] font-bold text-blue-600 dark:text-blue-400 tracking-widest uppercase transition-colors mb-1">
              {data.subtitle}
            </p>
            <p className="text-sm md:text-xl font-black text-slate-900 dark:text-white uppercase transition-colors">
              {data.highlight}
            </p>
          </div>
        </div>
        {/* END: Center Visual Area */}

        {/* BEGIN: Right Content Area (Promo Box) */}
        <div
          className="absolute top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2 md:relative md:top-0 md:-left-32 md:translate-x-0 md:translate-y-0 w-full md:w-[30%] max-w-[200px] md:max-w-[380px] bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm p-3 md:p-6 border border-gray-100 dark:border-slate-800 z-50 shadow-2xl transition-all duration-500 flex flex-col items-center text-center md:items-start md:text-left"
          data-purpose="promo-overlap-box"
        >
          <div className="space-y-2 md:space-y-2 flex flex-col items-center md:items-start w-full">
            <div className="inline-block bg-blue-600 text-white px-3 py-1 md:px-4 md:py-1 text-xs md:text-sm font-bold tracking-tighter uppercase mb-2">
              ƯU ĐÃI LỚN
            </div>
            <div className="flex flex-col">
              <span className="text-slate-400 dark:text-slate-500 font-bold line-through text-[10px] md:text-2xl transition-colors">
                3.500.000đ
              </span>
              <span className="text-lg md:text-5xl font-black text-slate-900 dark:text-white transition-colors">
                GIẢM GIÁ
              </span>
              <span className="text-xl md:text-6xl font-black text-blue-600 dark:text-blue-500 leading-none mt-0 transition-colors">
                50%
              </span>
            </div>
            <div className="pt-1.5 md:pt-4 w-full">
              <Link
                className="inline-block w-full bg-slate-900 dark:bg-blue-600 text-white text-center py-2 md:py-5 text-[10px] md:text-xl font-bold hover:bg-blue-700 dark:hover:bg-blue-500 transition-colors duration-300 uppercase tracking-widest shadow-lg"
                data-purpose="call-to-action"
                to="/products"
              >
                Mua Ngay
              </Link>
            </div>
          </div>
          {/* Subtle Corner Accent */}
          <div className="absolute -top-2 -right-2 w-10 h-10 border-t-4 border-r-4 border-blue-600"></div>
        </div>
        {/* END: Right Content Area */}
      </div>

      {/* Bottom Tech-Grid Overlay */}
      <div className="absolute bottom-0 left-0 w-full h-1/4 bg-gradient-to-t from-gray-100/50 dark:from-slate-900/50 to-transparent pointer-events-none transition-colors"></div>
    </section>
  );
};

export default PromoBanner;
